/** Tracks internal model updates to avoid recursive field logic execution. */
export class FormOperationState {
    private programmaticChange = false;

    public get isProgrammaticChange(): boolean {
        return this.programmaticChange;
    }

    public runProgrammaticChange(callback: () => void): void {
        this.programmaticChange = true;

        try {
            callback();
        } finally {
            this.programmaticChange = false;
        }
    }
}
